/** InsCoder 2026-08-09 B + Shared parent-child cart bundle helpers **/
(function(window) {
  'use strict';

  function createBundleId() {
    return 'cart-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
  }

  function setProperty(properties, key, value) {
    if (value === undefined || value === null || value === '') {
      return;
    }

    properties[key] = value;
  }

  function isPlaceholderValue(value) {
    var normalizedValue = value === undefined || value === null ? '' : String(value).trim();
    return normalizedValue === '' || normalizedValue === '-' || normalizedValue === '--' || normalizedValue === '—';
  }

  function titleCaseValue(value) {
    if (isPlaceholderValue(value)) {
      return '';
    }

    return String(value).trim().toLowerCase().replace(/(^|[\s-])([a-z])/g, function(match, prefix, character) {
      return prefix + character.toUpperCase();
    });
  }

  function uppercaseClarityGrades(value) {
    return String(value || '').replace(/\b(?:Fl|If|Vvs1|Vvs2|Vs1|Vs2|Si1|Si2|I1)\b/gi, function(match) {
      return match.toUpperCase();
    });
  }

  function formatStoneValue(value, type) {
    var formattedValue = titleCaseValue(value);

    if (type === 'colour' && /^[a-z]$/i.test(formattedValue)) {
      return formattedValue.toUpperCase();
    }

    if (type === 'clarity' && /^[a-z]{1,3}\d{0,2}$/i.test(formattedValue)) {
      return formattedValue.toUpperCase();
    }

    return formattedValue;
  }

  function formatCaratValue(value) {
    var normalizedValue = titleCaseValue(value).replace(/\s*ct\.?$/i, '').trim();

    if (!normalizedValue) {
      return '';
    }

    if (/^\d+(?:\.\d+)?$/.test(normalizedValue)) {
      normalizedValue = String(Number(normalizedValue));
    }

    return normalizedValue + 'ct';
  }

  function getPositionedChildLabel(label, optionKey) {
    var normalizedLabel = String(label || '').trim();
    var normalizedOptionKey = String(optionKey || '').trim().toLowerCase();

    if (!normalizedLabel || normalizedLabel.toUpperCase() === 'ADD-ON' || (normalizedOptionKey !== 'left' && normalizedOptionKey !== 'right')) {
      return normalizedLabel;
    }

    var stoneLabel = normalizedLabel.toUpperCase().indexOf('SAPPHIRE') !== -1 ? 'SAPPHIRE' : 'STONE';
    return normalizedOptionKey.toUpperCase() + ' ' + stoneLabel;
  }

  function normalizeProductProperties(properties) {
    var normalized = {};

    if (!properties || typeof properties !== 'object' || Array.isArray(properties)) {
      return normalized;
    }

    Object.keys(properties).forEach(function(key) {
      var value = properties[key];
      var normalizedKey = String(key || '').trim().replace(/:\s*$/, '');
      var normalizedValue = value === undefined || value === null ? '' : String(value).trim();

      if (normalizedKey && normalizedKey.charAt(0) !== '_' && !isPlaceholderValue(normalizedValue)) {
        normalized[normalizedKey] = normalizedValue;
      }
    });

    return normalized;
  }

  function isElementVisible(element) {
    var current = element;

    while (current && current.nodeType === 1) {
      if (window.getComputedStyle) {
        var style = window.getComputedStyle(current);

        if (style.display === 'none' || style.visibility === 'hidden') {
          return false;
        }
      }

      current = current.parentElement;
    }

    return true;
  }

  function getProductPropertiesScope(root) {
    var scope = root && typeof root.querySelectorAll === 'function' ? root : document;

    if (scope.matches && scope.matches('.product__properties') && isElementVisible(scope)) {
      return scope;
    }

    var visiblePropertyGroups = Array.prototype.filter.call(
      scope.querySelectorAll('.product__properties'),
      isElementVisible
    );

    return visiblePropertyGroups[0] || scope;
  }

  function collectProductProperties(root) {
    var scope = getProductPropertiesScope(root);
    var properties = {};

    Array.prototype.forEach.call(scope.querySelectorAll('.product__property'), function(property) {
      if (!isElementVisible(property)) {
        return;
      }

      var nameElement = property.querySelector('.product__property-name');
      var valueElement = property.querySelector('.product__property-value');
      if (!nameElement || !valueElement) {
        return;
      }

      var name = nameElement.textContent.trim().replace(/:\s*$/, '');
      var value = valueElement.textContent.trim();
      if (name && value && value !== '--' && value !== '—') {
        properties[name] = value;
      }
    });

    if (!Object.keys(properties).length) {
      Array.prototype.forEach.call(scope.querySelectorAll('tr'), function(row) {
        if (!isElementVisible(row)) {
          return;
        }

        var cells = row.querySelectorAll('th, td');
        if (cells.length < 2) {
          return;
        }

        var name = cells[0].textContent.trim().replace(/:\s*$/, '');
        var value = cells[1].textContent.trim();
        if (name && value && value !== '--' && value !== '—') {
          properties[name] = value;
        }
      });
    }

    return normalizeProductProperties(properties);
  }

  function getProductProperties(data, root) {
    var source = data || {};
    var properties = {};
    var type = String(source.type || source.diamond_type || source.gemstone_type || '').toLowerCase();
    var displayedType = type === 'lab' ? 'Lab Grown' : type === 'natural' ? 'Natural' : source.type;

    setProperty(properties, 'Stock Number', source.reference || source.stock_id || source.uid);
    setProperty(properties, 'Symmetry', source.symmetry);
    setProperty(properties, 'Diamond Type', displayedType);
    setProperty(properties, 'Polish', source.polish);
    setProperty(properties, 'Shape', source.shape);
    setProperty(properties, 'Measurements', source.measurements || source.msmt);
    setProperty(properties, 'Carat', source.carat || source.carat_weight);
    setProperty(properties, 'L/W Ratio', source.length_width_ratio);
    setProperty(properties, 'Colour', source.colour || source.color);
    setProperty(properties, 'Certification', source.lab || source.laboratory);
    setProperty(properties, 'Clarity', source.clarity);
    setProperty(properties, 'Cut', source.cut);
    setProperty(properties, 'Treatment', source.treatment);
    setProperty(properties, 'Origin', source.origin);
    setProperty(properties, 'SKU', source.sku || source.variant_sku || source.reference || source.uid);

    properties = Object.assign(
      properties,
      normalizeProductProperties(source.productProperties || source.cartProperties || source.lineItemProperties),
      root ? collectProductProperties(root) : {}
    );

    return normalizeProductProperties(properties);
  }

  function addChildItem(items, parentItem, childItem, childData) {
    if (!Array.isArray(items) || !parentItem || !childItem) {
      return '';
    }

    var data = childData || {};
    var parentProperties = parentItem.properties || {};
    var childProperties = childItem.properties || {};
    var bundleId = data.bundleId || parentProperties._cart_bundle_id || parentProperties._pave_bundle_id || createBundleId();

    parentProperties._cart_bundle_id = bundleId;
    parentProperties._cart_bundle_role = 'parent';
    childProperties._cart_bundle_id = bundleId;
    childProperties._cart_bundle_role = 'child';
    childProperties._cart_parent_variant_id = String(parentItem.id || '');

    setProperty(childProperties, '_cart_child_label', getPositionedChildLabel(data.label, data.optionKey));
    setProperty(childProperties, '_cart_child_title', data.title);
    setProperty(childProperties, '_cart_child_subtitle', data.subtitle);
    setProperty(childProperties, '_cart_child_image', data.image);
    setProperty(childProperties, '_cart_child_carat', data.carat);
    setProperty(childProperties, '_cart_child_shape', data.shape);
    setProperty(childProperties, '_cart_child_colour', data.colour || data.color);
    setProperty(childProperties, '_cart_child_cut', data.cut);
    setProperty(childProperties, '_cart_child_clarity', data.clarity);
    setProperty(childProperties, '_cart_child_measurements', data.measurements || data.msmt);
    setProperty(childProperties, '_cart_child_treatment', data.treatment);
    setProperty(childProperties, '_cart_child_origin', data.origin);
    setProperty(childProperties, '_cart_child_report', data.report || data.report_no || data.certificate);
    setProperty(childProperties, '_cart_child_reference', data.reference || data.stock_id);
    setProperty(childProperties, '_cart_child_lab', data.lab);
    setProperty(childProperties, '_cart_child_sku', data.sku);
    setProperty(childProperties, '_cart_child_option_key', data.optionKey);
    if (Array.isArray(data.options)) {
      childProperties._cart_child_options = JSON.stringify(data.options);
    }

    parentItem.properties = parentProperties;
    childItem.properties = childProperties;
    items.push(childItem);

    return bundleId;
  }

  function addChildVariant(items, parentItem, variantId, childData) {
    var child = childData || {};
    var childItem = {
      quantity: child.quantity || 1,
      id: Number(variantId),
      properties: Object.assign({}, child.properties || {})
    };

    return addChildItem(items, parentItem, childItem, child);
  }

  function normalizeChildData(data, fallbackLabel) {
    var source = data || {};
    var productProperties = getProductProperties(source);
    var type = String(source.type || source.gemstone_type || source.kind || '').toLowerCase();
    var label = source.label || (type.indexOf('sapphire') !== -1 ? 'SAPPHIRE' : fallbackLabel || 'STONE');
    var title = uppercaseClarityGrades(titleCaseValue(source.title || source.product_title || source.name || ''));
    var colour = formatStoneValue(source.colour || source.color || productProperties.Colour || productProperties.Color || '', 'colour');
    var carat = source.carat || source.carat_weight || productProperties.Carat || '';
    var measurements = source.measurements || source.msmt || productProperties.Measurements || '';
    var report = source.report || source.report_no || source.certificate || productProperties['Report Number'] || productProperties['Certificate Number'] || productProperties.Certificate || '';
    var laboratory = source.lab || source.laboratory || productProperties.Laboratory || productProperties.Lab || '';
    var reference = source.reference || source.stock_id || source.uid || productProperties['Stock Number'] || '';
    var cut = formatStoneValue(source.cut || productProperties.Cut || '', 'cut');
    var clarity = formatStoneValue(source.clarity || productProperties.Clarity || '', 'clarity');
    var shape = formatStoneValue(source.shape || productProperties.Shape || '', 'shape');
    var subtitle = [formatCaratValue(carat), shape, colour]
      .filter(function(value) { return value; })
      .join(' · ');

    return {
      label: label,
      title: title,
      subtitle: subtitle,
      image: source.image || source.image_url || source.imageUrl,
      carat: carat,
      shape: shape,
      colour: colour,
      cut: cut,
      clarity: clarity,
      measurements: measurements,
      treatment: source.treatment || productProperties.Treatment,
      origin: source.origin || productProperties.Origin,
      report: report,
      reference: reference,
      lab: laboratory || productProperties.Certification,
      sku: source.sku || source.variant_sku || productProperties.SKU || reference,
      optionKey: source.optionKey,
      options: source.options,
      properties: productProperties
    };
  }

  function normalizeRenderedStoneText(root) {
    var scope = root && typeof root.querySelectorAll === 'function' ? root : window.document;

    if (!scope) {
      return;
    }

    Array.prototype.forEach.call(scope.querySelectorAll('.cust-cart-line-item--child'), function(line) {
      var nameElement = line.querySelector('.cart__item-name');
      var subtitleElement = line.querySelector('.cust-cart-line-item__subtitle');
      var labelElement = line.querySelector('.cust-cart-line-item__eyebrow');
      var optionKey = line.getAttribute('data-cart-child-option-key');
      var description = {
        carat: '',
        shape: '',
        colour: ''
      };

      if (labelElement) {
        labelElement.textContent = getPositionedChildLabel(labelElement.textContent, optionKey);
      }

      if (nameElement) {
        nameElement.textContent = uppercaseClarityGrades(titleCaseValue(nameElement.textContent));
      }

      Array.prototype.forEach.call(line.querySelectorAll('.cust-cart-line-item__attribute'), function(attribute) {
        var labelElement = attribute.querySelector('.cust-cart-line-item__attribute-label');
        var valueElement = attribute.querySelector('.cust-cart-line-item__attribute-value');

        if (!labelElement || !valueElement) {
          return;
        }

        var rawValue = valueElement.textContent.trim();
        if (isPlaceholderValue(rawValue)) {
          attribute.hidden = true;
          return;
        }

        var label = labelElement.textContent.trim().toLowerCase();
        var valueType = label === 'shape' ? 'shape' : label === 'colour' || label === 'color' ? 'colour' : label === 'clarity' ? 'clarity' : '';

        if (label === 'carat') {
          description.carat = formatCaratValue(rawValue);
        } else if (valueType === 'shape') {
          description.shape = formatStoneValue(rawValue, valueType);
          valueElement.textContent = formatStoneValue(rawValue, valueType);
        } else if (valueType === 'colour') {
          description.colour = formatStoneValue(rawValue, valueType);
          valueElement.textContent = description.colour;
        } else if (valueType === 'clarity') {
          valueElement.textContent = formatStoneValue(rawValue, valueType);
        }
      });

      if (subtitleElement) {
        var descriptionText = [description.carat, description.shape, description.colour]
          .filter(function(value) { return value; })
          .join(' · ');
        subtitleElement.textContent = descriptionText || uppercaseClarityGrades(
          titleCaseValue(subtitleElement.textContent.replace(/^\s*-\s*\|\s*/, ''))
        );
      }
    });

    Array.prototype.forEach.call(scope.querySelectorAll('.cust-cart-summary__line--child span'), function(element) {
      element.textContent = uppercaseClarityGrades(titleCaseValue(element.textContent));
    });
  }

  window.KavalriCartBundle = {
    addChildItem: addChildItem,
    addChildVariant: addChildVariant,
    normalizeChildData: normalizeChildData,
    normalizeRenderedStoneText: normalizeRenderedStoneText,
    createBundleId: createBundleId,
    collectProductProperties: collectProductProperties,
    getProductProperties: getProductProperties
  };
})(window);

(function(window, document) {
  'use strict';

  function getDeleteCopy() {
    var strings = window.theme && window.theme.strings ? window.theme.strings : {};

    return {
      title: strings.cartBundleRemoveTitle || 'Remove this?',
      message: strings.cartBundleRemoveConfirmation || 'Removing this setting will also remove the selected stone from your cart.',
      cancel: strings.cartBundleRemoveCancel || 'Cancel',
      confirm: strings.cartBundleRemoveConfirm || 'Remove all'
    };
  }

  function formatNameList(names) {
    if (names.length < 2) {
      return names[0] || '';
    }

    if (names.length === 2) {
      return names[0] + ' and ' + names[1];
    }

    return names.slice(0, -1).join(', ') + ', and ' + names[names.length - 1];
  }

  function getBundleDeleteMessage(parentLine, fallbackMessage) {
    var group = parentLine.closest('[data-cart-group]');
    if (!group) {
      return fallbackMessage;
    }

    var parentNameElement = parentLine.querySelector('.cart__item-name');
    var parentName = parentNameElement ? parentNameElement.textContent.trim() : 'this setting';
    var childNames = Array.prototype.map.call(group.querySelectorAll('.cust-cart-line-item--child .cart__item-name'), function(element) {
      return element.textContent.trim();
    }).filter(function(name) {
      return name;
    });
    var childCount = Number(group.dataset.cartChildCount || childNames.length);
    var groupTotal = group.dataset.cartGroupTotal || '';
    var stoneLabel = childCount === 1 ? 'selected stone' : 'selected stones';
    var names = formatNameList(childNames);
    var message = 'Removing “' + parentName + '” will also remove its ' + childCount + ' ' + stoneLabel;

    if (names) {
      message += ' (' + names + ')';
    }
    if (groupTotal) {
      message += ', worth ' + groupTotal + ' combined';
    }

    return message + ". This can't be undone.";
  }

  function createDeleteScrim(parentLine) {
    var scrim = document.createElement('div');
    scrim.className = 'cust-cart-delete-scrim';
    scrim.setAttribute('aria-hidden', 'false');
    scrim.setAttribute('role', 'presentation');

    var copy = getDeleteCopy();
    var titleId = 'CustCartDeleteTitle-' + Date.now();
    var messageId = 'CustCartDeleteMessage-' + Date.now();
    scrim.innerHTML = '<div class="cust-cart-delete-dialog" role="dialog" aria-modal="true" aria-labelledby="' + titleId + '" aria-describedby="' + messageId + '">' +
      '<div class="cust-cart-delete-dialog__content">' +
        '<h2 class="cust-cart-delete-dialog__title" id="' + titleId + '"></h2>' +
        '<p class="cust-cart-delete-dialog__message" id="' + messageId + '"></p>' +
      '</div>' +
      '<div class="cust-cart-delete-dialog__actions">' +
        '<button type="button" class="cust-cart-delete-dialog__button cust-cart-delete-dialog__button--secondary" data-cart-delete-cancel>' + copy.cancel + '</button>' +
        '<button type="button" class="cust-cart-delete-dialog__button cust-cart-delete-dialog__button--primary" data-cart-delete-confirm>' + copy.confirm + '</button>' +
      '</div>' +
    '</div>';
    scrim.querySelector('.cust-cart-delete-dialog__title').textContent = copy.title;
    scrim.querySelector('.cust-cart-delete-dialog__message').textContent = getBundleDeleteMessage(parentLine, copy.message);

    document.body.appendChild(scrim);
    document.documentElement.classList.add('cust-cart-delete-open');

    return {
      scrim: scrim,
      dialog: scrim.querySelector('.cust-cart-delete-dialog'),
      confirmButton: scrim.querySelector('[data-cart-delete-confirm]'),
      cancelButtons: scrim.querySelectorAll('[data-cart-delete-cancel]')
    };
  }

  function destroyDeleteScrim(modal) {
    if (!modal || !modal.scrim) {
      return;
    }

    document.documentElement.classList.remove('cust-cart-delete-open');
    modal.scrim.setAttribute('aria-hidden', 'true');
    if (modal.scrim.parentNode) {
      modal.scrim.parentNode.removeChild(modal.scrim);
    }
  }

  function updateBundle(parentLine, updates, targetGroup, modal) {
    targetGroup.classList.add('is-removing');
    var removeButton = parentLine.querySelector('[data-cart-parent-remove]');
    if (removeButton) {
      removeButton.setAttribute('aria-disabled', 'true');
    }

    window.theme.cart._updateCart({
      url: '/cart/update.js?t=' + Date.now(),
      data: JSON.stringify({ updates: updates })
    }).then(function(cart) {
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    }).catch(function(error) {
      console.error('Unable to remove cart bundle', error);
    }).finally(function() {
      targetGroup.classList.remove('is-removing');
      destroyDeleteScrim(modal);
    });
  }

  function removeBundle(parentLine) {
    var bundleId = parentLine && parentLine.dataset.cartBundleId;
    if (!bundleId || !window.theme || !window.theme.cart || typeof window.theme.cart._updateCart !== 'function') {
      return false;
    }

    var group = parentLine.closest('[data-cart-group]');
    var lines = group ? group.querySelectorAll('[data-cart-item-key]') : Array.prototype.filter.call(document.querySelectorAll('[data-cart-bundle-id]'), function(line) {
      return line.dataset.cartBundleId === bundleId;
    });
    var updates = {};

    lines.forEach(function(line) {
      var key = line.dataset.cartItemKey || line.dataset.key;
      if (key) {
        updates[key] = 0;
      }
    });

    if (!Object.keys(updates).length) {
      return false;
    }

    var targetGroup = group || parentLine;
    var modal = createDeleteScrim(parentLine);
    var closeModal = function() {
      destroyDeleteScrim(modal);
    };

    modal.cancelButtons.forEach(function(button) {
      button.addEventListener('click', closeModal);
    });
    modal.scrim.addEventListener('click', function(event) {
      if (event.target === modal.scrim) {
        closeModal();
      }
    });
    modal.confirmButton.addEventListener('click', function() {
      modal.confirmButton.disabled = true;
      modal.confirmButton.setAttribute('aria-busy', 'true');
      updateBundle(parentLine, updates, targetGroup, modal);
    });
    modal.scrim.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
      }
    });

    window.requestAnimationFrame(function() {
      modal.cancelButtons[0].focus();
    });

    return true;
  }

  function removeSingleItem(line) {
    var key = line && (line.dataset.cartItemKey || line.dataset.key);
    if (!key || !window.theme || !window.theme.cart || typeof window.theme.cart._updateCart !== 'function') {
      return false;
    }

    var removeButton = line.querySelector('[data-cart-item-remove]');
    line.classList.add('is-removing');
    if (removeButton) {
      removeButton.setAttribute('aria-disabled', 'true');
    }

    window.theme.cart._updateCart({
      url: '/cart/update.js?t=' + Date.now(),
      data: JSON.stringify({ updates: { [key]: 0 } })
    }).then(function(cart) {
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    }).catch(function(error) {
      console.error('Unable to remove cart item', error);
    }).finally(function() {
      line.classList.remove('is-removing');
      if (removeButton) {
        removeButton.removeAttribute('aria-disabled');
      }
    });

    return true;
  }

  function updateNoteCount(input) {
    var counter = input.closest('.cust-cart-note').querySelector('[data-cart-note-count]');
    if (!counter) {
      return;
    }

    counter.textContent = input.value.length + ' / ' + (input.maxLength || 250) + ' characters';
  }

  function updateHeaderCounts(count) {
    var nextCount = String(count);
    document.querySelectorAll('[data-cart-header-count]').forEach(function(element) {
      if (element.textContent !== nextCount) {
        element.textContent = nextCount;
      }
    });
  }

  function getSummaryItemCount(cart) {
    if (!cart || !Array.isArray(cart.items)) {
      return 0;
    }

    return cart.items.reduce(function(total, item) {
      var properties = item.properties || {};
      var bundleRole = properties._cart_bundle_role || properties._pave_role || '';
      var expeditedRole = properties._expedited_shipping_role || '';

      if (bundleRole === 'child' || expeditedRole === 'addon') {
        return total;
      }

      return total + (Number(item.quantity) || 0);
    }, 0);
  }

  function updateSummaryItemCounts(count) {
    document.querySelectorAll('[data-cart-summary-count-label]').forEach(function(element) {
      var template = element.dataset.countTemplate || '';
      element.textContent = template.replace('[count]', String(count));
    });
  }

  function updateCartTotals(totalPrice) {
    if (!window.theme || !window.theme.Currency || typeof window.theme.Currency.formatMoney !== 'function') {
      return;
    }

    var moneyFormat = window.theme.settings.moneyWithCurrencyFormat || window.theme.settings.moneyFormat;
    var formattedTotal = window.theme.Currency.formatMoney(totalPrice, moneyFormat);
    document.querySelectorAll('[data-subtotal], [data-cart-total]').forEach(function(element) {
      element.innerHTML = formattedTotal;
    });
  }

  function getTermsElements(checkoutButton) {
    var form = checkoutButton && checkoutButton.closest('form');
    var checkbox = form && form.querySelector('.cart__terms-checkbox');

    return {
      form: form,
      checkbox: checkbox,
      error: checkbox && form.querySelector('[data-cart-terms-error]')
    };
  }

  function clearTermsError(checkbox, error) {
    if (!checkbox) {
      return;
    }

    checkbox.removeAttribute('aria-invalid');
    if (error) {
      error.hidden = true;
    }
  }

  function validateCheckoutTerms(checkoutButton) {
    if (!checkoutButton || checkoutButton.dataset.termsRequired !== 'true') {
      return true;
    }

    var elements = getTermsElements(checkoutButton);
    if (!elements.checkbox || elements.checkbox.checked) {
      clearTermsError(elements.checkbox, elements.error);
      return true;
    }

    elements.checkbox.setAttribute('aria-invalid', 'true');
    if (elements.error) {
      elements.error.hidden = false;
    }
    elements.checkbox.focus();
    return false;
  }

  function syncHeaderCountFromMarkup() {
    var summaryCount = document.querySelector('[data-cart-summary-count]');
    if (summaryCount) {
      updateHeaderCounts(summaryCount.dataset.cartSummaryCount || 0);
      return;
    }

    var cartItems = document.querySelector('.cart__items[data-count]');
    if (cartItems) {
      updateHeaderCounts(cartItems.dataset.count || 0);
    }
  }

  document.addEventListener('input', function(event) {
    var input = event.target.closest('[data-cart-note-input]');
    if (input) {
      updateNoteCount(input);
    }
  });

  document.addEventListener('change', function(event) {
    var checkbox = event.target.closest('.cart__terms-checkbox');
    if (!checkbox || !checkbox.checked) {
      return;
    }

    var form = checkbox.closest('form');
    clearTermsError(checkbox, form && form.querySelector('[data-cart-terms-error]'));
  });

  document.addEventListener('click', function(event) {
    var checkoutButton = event.target.closest('.cart__checkout[data-terms-required="true"]');
    if (!checkoutButton || validateCheckoutTerms(checkoutButton)) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  document.addEventListener('submit', function(event) {
    var form = event.target;
    var checkoutButton = form && form.querySelector('.cart__checkout[data-terms-required="true"]');
    if (!checkoutButton || validateCheckoutTerms(checkoutButton)) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  document.addEventListener('click', function(event) {
    /** InsCoder WANG.J 2026-08-18 B + Cart order summary opens only via its toggle icon, not the header text **/
    var summaryHeader = event.target.closest('.cust-cart-summary__header');
    if (summaryHeader) {
      var summaryDetails = summaryHeader.closest('.cust-cart-summary');
      if (summaryDetails) {
        event.preventDefault();
        if (event.target.closest('.cust-cart-summary__toggle')) {
          summaryDetails.open = !summaryDetails.open;
        }
      }
      return;
    }
    /** InsCoder WANG.J 2026-08-18 E + Cart order summary opens only via its toggle icon, not the header text **/

    var detailsToggle = event.target.closest('[data-cart-details-toggle]');
    if (detailsToggle) {
      var details = document.getElementById(detailsToggle.getAttribute('aria-controls'));
      if (details) {
        details.open = !details.open;
        detailsToggle.setAttribute('aria-expanded', String(details.open));
        var toggleLabel = detailsToggle.querySelector('.visually-hidden');
        if (toggleLabel) {
          toggleLabel.textContent = details.open ? 'Collapse stone details' : 'Expand stone details';
        }
      }
      return;
    }

    var parentRemove = event.target.closest('[data-cart-parent-remove]');
    if (parentRemove) {
      event.preventDefault();
      var parentLine = parentRemove.closest('[data-cart-line-item--parent]');
      if (parentLine) {
        removeBundle(parentLine);
        event.stopImmediatePropagation();
        return;
      }
    }

    var itemRemove = event.target.closest('[data-cart-item-remove]');
    if (itemRemove && !itemRemove.hasAttribute('data-cart-parent-remove')) {
      var itemLine = itemRemove.closest('[data-cart-item-key]');
      if (itemLine && removeSingleItem(itemLine)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
    }

    var saveButton = event.target.closest('[data-cart-note-save]');
    var cancelButton = event.target.closest('[data-cart-note-cancel]');
    var button = saveButton || cancelButton;

    if (!button) {
      return;
    }

    var note = button.closest('.cust-cart-note');
    var input = note && note.querySelector('[data-cart-note-input]');
    if (!note || !input) {
      return;
    }

    if (cancelButton) {
      input.value = input.dataset.cartNoteOriginal || '';
      if (window.theme && window.theme.cart && typeof window.theme.cart.updateNote === 'function') {
        window.theme.cart.updateNote(input.value);
      }
    } else {
      input.dataset.cartNoteOriginal = input.value;
      if (window.theme && window.theme.cart && typeof window.theme.cart.updateNote === 'function') {
        window.theme.cart.updateNote(input.value);
      }
    }

    updateNoteCount(input);
    note.open = false;
  });

  document.addEventListener('cart:updated', function(event) {
    var cart = event.detail && event.detail.cart;
    if (cart) {
      if (window.KavalriCartBundle && typeof window.KavalriCartBundle.normalizeRenderedStoneText === 'function') {
        window.KavalriCartBundle.normalizeRenderedStoneText();
      }
      var summaryItemCount = getSummaryItemCount(cart);
      updateHeaderCounts(summaryItemCount);
      updateSummaryItemCounts(summaryItemCount);
      updateCartTotals(cart.total_price);
    }
  });

  document.querySelectorAll('[data-cart-note-input]').forEach(updateNoteCount);
  if (window.KavalriCartBundle && typeof window.KavalriCartBundle.normalizeRenderedStoneText === 'function') {
    window.KavalriCartBundle.normalizeRenderedStoneText();
  }
  syncHeaderCountFromMarkup();
})(window, document);
/** InsCoder 2026-08-09 G + Cart helpers and collapsible note behavior **/

/** InsCoder 2026-08-17 B + URL-scoped cart editing for standalone products and ring/stone bundles. **/
(function(window, document) {
  'use strict';

  var EDIT_PARAM = 'edit_cart_id';
  var CACHE_PREFIX = 'kavalri-cart-edit-v1:';
  var FLOW_PARAMS = [
    EDIT_PARAM,
    'path',
    'product_handle',
    'collection_handle',
    'selected_variant_id',
    'ring_size',
    'children_variant_id'
  ];
  var MARKED_STORAGE_KEYS = [
    'diamond-selected-item',
    'diamond-selected-left-item',
    'alpine-gemstone-stepItem'
  ];
  var contextPromise = null;
  var activeEditCartId = new URLSearchParams(window.location.search).get(EDIT_PARAM) || '';
  var editSubmissionPromise = null;
  var cartMutationQueue = Promise.resolve();

  function getEditId() {
    return new URLSearchParams(window.location.search).get(EDIT_PARAM) || activeEditCartId;
  }

  function cloneObject(value) {
    return Object.assign({}, value || {});
  }

  function getProperties(line) {
    return cloneObject(line && line.properties);
  }

  function getBundleId(line) {
    var properties = getProperties(line);
    return properties._cart_bundle_id || properties._pave_bundle_id || '';
  }

  function getBundleRole(line) {
    var properties = getProperties(line);
    return properties._cart_bundle_role || properties._pave_role || '';
  }

  function getEditLinkIdentity(editLink) {
    if (!editLink || typeof editLink.closest !== 'function') {
      return null;
    }

    var lineElement = editLink.closest('[data-cart-item-key]');
    if (!lineElement) {
      return null;
    }

    var productPath = '';
    try {
      var linkUrl = new URL(editLink.getAttribute('href') || '', window.location.origin);
      productPath = linkUrl.pathname === '/cart' ? '' : linkUrl.pathname;
    } catch (error) {
      productPath = '';
    }

    return {
      bundleId: lineElement.getAttribute('data-cart-bundle-id') || '',
      role: lineElement.getAttribute('data-cart-bundle-role') || '',
      variantId: lineElement.getAttribute('data-variant-id') || '',
      productPath: productPath
    };
  }

  function getLinePath(line) {
    if (!line || !line.url) {
      return '';
    }

    try {
      return new URL(line.url, window.location.origin).pathname;
    } catch (error) {
      return String(line.url).split('?')[0];
    }
  }

  function matchesEditLinkIdentity(line, identity) {
    if (!line || !identity) {
      return false;
    }

    var variantId = String(line.variant_id || line.id || '');
    if (identity.variantId && variantId !== String(identity.variantId)) {
      return false;
    }

    if (identity.bundleId) {
      return getBundleId(line) === identity.bundleId &&
        (!identity.role || getBundleRole(line) === identity.role);
    }

    return !identity.productPath || getLinePath(line) === identity.productPath;
  }

  function resolveEditTargetLine(items, editCartId, editLink) {
    var exactLine = items.find(function(item) { return item.key === editCartId; });
    if (exactLine) {
      return exactLine;
    }

    var identity = getEditLinkIdentity(editLink);
    if (!identity || (!identity.bundleId && !identity.variantId && !identity.productPath)) {
      return null;
    }

    var candidates = items.filter(function(item) {
      return matchesEditLinkIdentity(item, identity);
    });

    // A stale key can be recovered only when the DOM identifies one unique
    // current cart line. Never guess between duplicate variants.
    return candidates.length === 1 ? candidates[0] : null;
  }

  function isAddOn(line) {
    var properties = getProperties(line);
    return properties._cart_child_label === 'ADD-ON' ||
      properties._expedited_shipping_role === 'addon' ||
      Boolean(properties._pave_option_key || properties._pave_options || properties['Pave Option']);
  }

  function getStoneType(line) {
    var properties = getProperties(line);
    var label = String(properties._cart_child_label || '').toUpperCase();
    var searchable = [
      properties._cart_child_title,
      properties._cart_child_subtitle,
      line && line.product_title,
      line && line.title,
      line && line.product_type
    ].filter(Boolean).join(' ').toLowerCase();

    if (label === 'SAPPHIRE' || label.endsWith(' SAPPHIRE') || searchable.indexOf('sapphire') !== -1) {
      return 'sapphire';
    }
    if (label === 'STONE' || label.endsWith(' STONE') || searchable.indexOf('diamond') !== -1) {
      return 'diamond';
    }
    return '';
  }

  function getDiamondType(line) {
    var properties = getProperties(line);
    var searchable = [
      properties._cart_child_title,
      properties._cart_child_subtitle,
      line && line.product_title,
      line && line.title
    ].filter(Boolean).join(' ').toLowerCase();

    return searchable.indexOf('natural') !== -1 ? 'natural' : 'lab';
  }

  function getLineImage(line) {
    if (!line) {
      return '';
    }
    return (line.featured_image && line.featured_image.url) || line.image || getProperties(line)._cart_child_image || '';
  }

  function getLineHandle(line) {
    var productPath = String(line && line.url || '').split('/products/')[1] || '';
    return line && line.handle || productPath.split('?')[0] || '';
  }

  function wait(milliseconds) {
    return new Promise(function(resolve) {
      window.setTimeout(resolve, milliseconds);
    });
  }

  function fetchJSON(url, options, attempt) {
    var retryAttempt = Number(attempt) || 0;
    return fetch(url, Object.assign({
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }, options || {})).then(function(response) {
      return response.text().then(function(responseText) {
        var data;
        try {
          data = responseText ? JSON.parse(responseText) : {};
        } catch (error) {
          data = {};
        }

        if (response.status === 429 && retryAttempt < 3) {
          var retryAfter = Number(response.headers.get('Retry-After'));
          var retryDelay = retryAfter > 0
            ? Math.min(retryAfter * 1000, 3000)
            : Math.min(500 * Math.pow(2, retryAttempt), 2000);
          return wait(retryDelay).then(function() {
            return fetchJSON(url, options, retryAttempt + 1);
          });
        }

        if (!response.ok || data.status >= 400) {
          var error = new Error(data.description || data.message || 'Unable to update the cart.');
          error.response = data;
          error.status = response.status;
          throw error;
        }
        return data;
      });
    });
  }

  function enqueueCartMutation(request) {
    var queuedRequest = cartMutationQueue.catch(function() {
      return null;
    }).then(request);
    cartMutationQueue = queuedRequest.catch(function() {
      return null;
    });
    return queuedRequest;
  }

  function patchThemeCartRequests() {
    if (!window.theme || !window.theme.cart || window.theme.cart._cartEditRateLimitPatched) {
      return;
    }

    window.theme.cart._updateCart = function(params) {
      return enqueueCartMutation(function() {
        return fetchJSON(params.url, {
          method: 'POST',
          body: params.data
        });
      });
    };
    window.theme.cart._cartEditRateLimitPatched = true;
  }

  function fetchCart() {
    return fetchJSON('/cart.js?t=' + Date.now(), { method: 'GET', headers: {} });
  }

  function buildContext(cart, editCartId, editLink) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var targetLine = resolveEditTargetLine(items, editCartId, editLink);

    if (!targetLine) {
      var unavailableError = new Error('This cart item is no longer available.');
      unavailableError.code = 'CART_EDIT_LINE_NOT_FOUND';
      throw unavailableError;
    }

    var resolvedEditCartId = targetLine.key;

    var bundleId = getBundleId(targetLine);
    var role = getBundleRole(targetLine);
    var bundleLines = bundleId ? items.filter(function(item) {
      return getBundleId(item) === bundleId;
    }) : [targetLine];
    var parentLine = bundleLines.find(function(item) {
      return getBundleRole(item) === 'parent';
    }) || null;
    var childLines = bundleLines.filter(function(item) {
      return getBundleRole(item) === 'child';
    });
    var stoneLine = role === 'child' && !isAddOn(targetLine)
      ? targetLine
      : childLines.find(function(item) { return !isAddOn(item); });
    var targetRole = role === 'parent' ? 'parent' : role === 'child' ? 'child' : 'standalone';
    var stoneType = stoneLine ? getStoneType(stoneLine) : '';

    if (targetRole !== 'standalone' && (!parentLine || !stoneType)) {
      throw new Error('The ring and stone combination could not be identified.');
    }

    return {
      version: 1,
      editCartId: resolvedEditCartId,
      targetRole: targetRole,
      bundleId: bundleId || null,
      stoneType: stoneType || null,
      targetLine: targetLine,
      parentLine: parentLine,
      childLines: childLines,
      fixedLines: targetRole === 'parent' ? childLines : parentLine ? [parentLine] : [],
      originalLineKeys: bundleLines.map(function(item) { return item.key; }),
      initializedAt: Date.now()
    };
  }

  function cacheContext(context) {
    try {
      sessionStorage.setItem(CACHE_PREFIX + context.editCartId, JSON.stringify(context));
    } catch (error) {
      console.warn('Unable to cache cart edit context', error);
    }
    return context;
  }

  function readCachedContext(editCartId) {
    try {
      return JSON.parse(sessionStorage.getItem(CACHE_PREFIX + editCartId) || 'null');
    } catch (error) {
      return null;
    }
  }

  function validateCachedContext(cached, current) {
    if (!cached) {
      return;
    }

    var cachedKeys = (cached.originalLineKeys || []).slice().sort().join('|');
    var currentKeys = (current.originalLineKeys || []).slice().sort().join('|');
    if (
      cached.targetRole !== current.targetRole ||
      cached.bundleId !== current.bundleId ||
      cachedKeys !== currentKeys
    ) {
      throw new Error('This cart item has changed in another tab.');
    }
  }

  function getContext(force) {
    var editCartId = getEditId();
    if (!editCartId) {
      return Promise.resolve(null);
    }
    if (!force && contextPromise) {
      return contextPromise;
    }

    var cachedContext = readCachedContext(editCartId);
    contextPromise = fetchCart().then(function(cart) {
      var currentContext = buildContext(cart, editCartId);
      validateCachedContext(cachedContext, currentContext);
      if (cachedContext && cachedContext.initializedAt) {
        currentContext.initializedAt = cachedContext.initializedAt;
      }
      return cacheContext(currentContext);
    }).catch(function(error) {
      contextPromise = null;
      throw error;
    });
    return contextPromise;
  }

  function createRingSelection(line, editCartId) {
    var properties = getProperties(line);
    return {
      id: line.product_id || line.id || line.key,
      handle: getLineHandle(line),
      product_title: line.product_title || line.title || '',
      title: line.product_title || line.title || '',
      price: Number(line.final_price || line.price || 0) / 100,
      image_url: getLineImage(line),
      variant_title: line.variant_title || '',
      variantId: String(line.variant_id || line.id || ''),
      ringSize: properties['Ring Size'] || '',
      childrenVariantId: '',
      collection_handle: 'engagement-rings-australia',
      type: 'express',
      _cartEditId: editCartId,
      _cartEditLocked: true
    };
  }

  function createStoneSelection(line, editCartId, stoneType) {
    var properties = getProperties(line);
    return {
      id: line.key,
      uid: properties._cart_child_reference || properties._cart_child_sku || line.key,
      variant_id: String(line.variant_id || line.id || ''),
      product_title: properties._cart_child_title || line.product_title || line.title || '',
      title: properties._cart_child_title || line.product_title || line.title || '',
      image_url: properties._cart_child_image || getLineImage(line),
      price: Number(line.final_price || line.price || 0) / 100,
      carat: properties._cart_child_carat || '',
      shape: properties._cart_child_shape || '',
      color: properties._cart_child_colour || '',
      colour: properties._cart_child_colour || '',
      clarity: properties._cart_child_clarity || '',
      cut: properties._cart_child_cut || '',
      reference: properties._cart_child_reference || '',
      sku: properties._cart_child_sku || '',
      type: stoneType,
      _cartEditId: editCartId,
      _cartEditLocked: true
    };
  }

  function getPrimaryStone(context) {
    return context.childLines.find(function(line) {
      return !isAddOn(line) && getStoneType(line) === context.stoneType;
    }) || null;
  }

  function getFlowStoneType(context) {
    var params = new URLSearchParams(window.location.search);
    if (context && context.targetRole === 'child') {
      if (params.get('view') === 'gemstones' || params.get('diamond') === 'sapphire') {
        return 'sapphire';
      }
      return 'diamond';
    }
    return context && context.stoneType;
  }

  function stageContext(context) {
    if (!context || context.targetRole === 'standalone') {
      return context;
    }

    if (context.targetRole === 'child') {
      var ringSelection = createRingSelection(context.parentLine, context.editCartId);
      if (getFlowStoneType(context) === 'sapphire') {
        localStorage.setItem('alpine-gemstone-stepItem', JSON.stringify(ringSelection));
        localStorage.setItem('alpine-gemstone-step', '2');
      } else {
        localStorage.setItem('diamond-selected-item', JSON.stringify(ringSelection));
      }
    } else {
      var stoneLine = getPrimaryStone(context);
      var stoneSelection = createStoneSelection(stoneLine, context.editCartId, context.stoneType);
      if (context.stoneType === 'sapphire') {
        localStorage.setItem('alpine-gemstone-stepItem', JSON.stringify(stoneSelection));
        localStorage.setItem('alpine-gemstone-step', '2');
      } else {
        localStorage.setItem('diamond-selected-item', JSON.stringify(stoneSelection));
      }
    }

    return context;
  }

  function clearMarkedSelections(editCartId) {
    MARKED_STORAGE_KEYS.forEach(function(key) {
      try {
        var value = JSON.parse(localStorage.getItem(key) || 'null');
        if (value && value._cartEditId && (!editCartId || value._cartEditId === editCartId)) {
          localStorage.removeItem(key);
        }
      } catch (error) {
        // Preserve unrelated malformed legacy values.
      }
    });

    var gemstoneStep = localStorage.getItem('alpine-gemstone-stepItem');
    if (!gemstoneStep) {
      localStorage.removeItem('alpine-gemstone-step');
      localStorage.removeItem('alpine-gemstone-gemstoneId');
      localStorage.removeItem('alpine-gemstone-collection-href');
    }
  }

  function clearEditState(editCartId) {
    var id = editCartId || getEditId();
    clearMarkedSelections(id);
    if (id) {
      sessionStorage.removeItem(CACHE_PREFIX + id);
    }
    contextPromise = null;
    editSubmissionPromise = null;
    activeEditCartId = '';
  }

  function clearAllEditCaches() {
    Object.keys(sessionStorage).forEach(function(key) {
      if (key.indexOf(CACHE_PREFIX) === 0) {
        sessionStorage.removeItem(key);
      }
    });
  }

  function appendFlowParams(destinationUrl) {
    var destination = new URL(destinationUrl, window.location.origin);
    var current = new URL(window.location.href);

    FLOW_PARAMS.forEach(function(name) {
      if (!destination.searchParams.has(name) && current.searchParams.has(name)) {
        destination.searchParams.set(name, current.searchParams.get(name));
      }
    });

    if (!destination.searchParams.has(EDIT_PARAM) && activeEditCartId) {
      destination.searchParams.set(EDIT_PARAM, activeEditCartId);
    }

    return destination.pathname + destination.search + destination.hash;
  }

  function navigate(destinationUrl) {
    window.location.href = appendFlowParams(destinationUrl);
  }

  function getEditDestination(context) {
    var destination;
    if (context.targetRole === 'standalone') {
      destination = new URL(context.targetLine.url, window.location.origin);
      destination.searchParams.set('variant', context.targetLine.variant_id);
    } else if (context.targetRole === 'parent') {
      var fixedStone = getPrimaryStone(context);
      var fixedStoneProperties = getProperties(fixedStone);
      var fixedShape = String(fixedStoneProperties._cart_child_shape || '').trim();
      destination = new URL('/collections/engagement-rings-australia', window.location.origin);
      destination.searchParams.set('view', context.stoneType === 'sapphire' ? 'sapphire' : 'diamond');
      destination.searchParams.set('local', 'true');
      destination.searchParams.set('diamond', context.stoneType === 'sapphire' ? 'sapphire' : getDiamondType(fixedStone));
      if (fixedShape) {
        destination.searchParams.append('filter.p.tag', fixedShape.toLowerCase());
        destination.searchParams.append('filter.p.tag', fixedShape.toUpperCase());
        destination.searchParams.append('filter.p.tag', fixedShape.charAt(0).toUpperCase() + fixedShape.slice(1).toLowerCase());
      }
    } else {
      var parent = context.parentLine;
      var parentProperties = getProperties(parent);
      destination = new URL('/pages/engagement-rings', window.location.origin);
      destination.searchParams.set('view', context.stoneType === 'sapphire' ? 'gemstones' : 'diamond-list');
      destination.searchParams.set('path', 'express');
      destination.searchParams.set('product_handle', getLineHandle(parent));
      destination.searchParams.set('collection_handle', 'engagement-rings-australia');
      destination.searchParams.set('selected_variant_id', parent.variant_id);
      destination.searchParams.set('ring_size', parentProperties['Ring Size'] || '');
      destination.searchParams.set('diamond', context.stoneType === 'sapphire' ? 'sapphire' : getDiamondType(context.targetLine));

      var paveLine = context.childLines.find(function(line) { return isAddOn(line); });
      if (paveLine) {
        destination.searchParams.set('children_variant_id', paveLine.variant_id);
      }
    }

    destination.searchParams.set(EDIT_PARAM, context.editCartId);
    return destination.pathname + destination.search;
  }

  function postAdd(items) {
    return fetchJSON('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify({ items: items })
    });
  }

  function removeKeys(keys) {
    var updates = {};
    keys.forEach(function(key) {
      if (key) {
        updates[key] = 0;
      }
    });
    return fetchJSON('/cart/update.js', {
      method: 'POST',
      body: JSON.stringify({ updates: updates })
    });
  }

  function lineItemPayload(line, properties) {
    var payload = {
      id: Number(line.variant_id || line.id),
      quantity: Number(line.quantity) || 1,
      properties: cloneObject(properties === undefined ? line.properties : properties)
    };
    if (line.selling_plan_allocation && line.selling_plan_allocation.selling_plan) {
      payload.selling_plan = line.selling_plan_allocation.selling_plan.id;
    } else if (line.selling_plan) {
      payload.selling_plan = line.selling_plan;
    }
    return payload;
  }

  function sameProperties(left, right) {
    return JSON.stringify(left || {}) === JSON.stringify(right || {});
  }

  function submitEditOnce(callback) {
    if (editSubmissionPromise) {
      return editSubmissionPromise;
    }

    editSubmissionPromise = Promise.resolve().then(callback).catch(function(error) {
      editSubmissionPromise = null;
      throw error;
    });
    return editSubmissionPromise;
  }

  function verifyRemovedLines(cart, lineKeys) {
    var remainingKeys = (cart && Array.isArray(cart.items) ? cart.items : []).filter(function(line) {
      return lineKeys.indexOf(line.key) !== -1;
    }).map(function(line) {
      return line.key;
    });

    if (remainingKeys.length) {
      throw new Error('The original cart item could not be removed. Please try again.');
    }
    return cart;
  }

  function finishEdit(context) {
    clearEditState(context.editCartId);
    if (window.KavalriPaveOption && typeof window.KavalriPaveOption.clearSelection === 'function') {
      window.KavalriPaveOption.clearSelection();
    }
    window.location.href = '/cart';
  }

  function replaceStandalone(variantId, quantity, properties) {
    return submitEditOnce(function() {
      return getContext(true).then(function(context) {
        if (!context || context.targetRole !== 'standalone') {
          throw new Error('The selected cart item cannot be edited on this page.');
        }
        var original = context.targetLine;
        var nextProperties = Object.assign({}, getProperties(original), properties || {});
        var nextQuantity = Number(quantity) || Number(original.quantity) || 1;
        var nextVariantId = Number(variantId);

        if (Number(original.variant_id) === nextVariantId) {
          if (Number(original.quantity) === nextQuantity && sameProperties(getProperties(original), nextProperties)) {
            finishEdit(context);
            return null;
          }
          return fetchJSON('/cart/change.js', {
            method: 'POST',
            body: JSON.stringify({
              id: original.key,
              quantity: nextQuantity,
              properties: nextProperties
            })
          }).then(function() { finishEdit(context); });
        }

        return postAdd([{
          id: nextVariantId,
          quantity: nextQuantity,
          properties: nextProperties
        }]).then(function(added) {
          var addedLine = added.items ? added.items[0] : added;
          return removeKeys([original.key]).then(function(cart) {
            return verifyRemovedLines(cart, [original.key]);
          }).catch(function(error) {
            if (addedLine && addedLine.key) {
              return removeKeys([addedLine.key]).then(function() { throw error; });
            }
            throw error;
          });
        }).then(function() { finishEdit(context); });
      });
    });
  }

  function replaceChild(variantId, childData) {
    return submitEditOnce(function() {
      return getContext(true).then(function(context) {
        if (!context || context.targetRole !== 'child') {
          throw new Error('The selected stone is no longer available to edit.');
        }
        var original = context.targetLine;
        var parentItem = lineItemPayload(context.parentLine);
        var items = [parentItem];
        var normalizedData = window.KavalriCartBundle && window.KavalriCartBundle.normalizeChildData
          ? window.KavalriCartBundle.normalizeChildData(childData || {}, getFlowStoneType(context) === 'sapphire' ? 'SAPPHIRE' : 'STONE')
          : childData || {};

        var originalOptionKey = getProperties(original)._cart_child_option_key;
        if (!normalizedData.optionKey && originalOptionKey) {
          normalizedData.optionKey = originalOptionKey;
        }

        normalizedData.bundleId = context.bundleId;
        if (!window.KavalriCartBundle || typeof window.KavalriCartBundle.addChildVariant !== 'function') {
          throw new Error('Unable to prepare the selected stone.');
        }
        window.KavalriCartBundle.addChildVariant(items, parentItem, variantId, normalizedData);
        var replacement = items[1];
        replacement.quantity = Number(original.quantity) || 1;

        if (Number(original.variant_id) === Number(variantId) && sameProperties(getProperties(original), replacement.properties)) {
          finishEdit(context);
          return null;
        }

        return postAdd([replacement]).then(function(added) {
          var addedLine = added.items ? added.items[0] : added;
          return removeKeys([original.key]).then(function(cart) {
            return verifyRemovedLines(cart, [original.key]);
          }).catch(function(error) {
            if (addedLine && addedLine.key) {
              return removeKeys([addedLine.key]).then(function() { throw error; });
            }
            throw error;
          });
        }).then(function() { finishEdit(context); });
      });
    });
  }

  function rollbackBundle(bundleId) {
    return fetchCart().then(function(cart) {
      return removeKeys(cart.items.filter(function(line) {
        return getBundleId(line) === bundleId;
      }).map(function(line) { return line.key; }));
    });
  }

  function replaceParent(variantId, ringSize, properties) {
    return submitEditOnce(function() {
      return getContext(true).then(function(context) {
        if (!context || context.targetRole !== 'parent') {
          throw new Error('The selected ring is no longer available to edit.');
        }

        var originalParentProperties = getProperties(context.parentLine);
        var requestedParentProperties = Object.assign({}, originalParentProperties, properties || {});
        if (ringSize) {
          requestedParentProperties['Ring Size'] = ringSize;
        }
        if (
          Number(context.parentLine.variant_id) === Number(variantId) &&
          sameProperties(originalParentProperties, requestedParentProperties)
        ) {
          finishEdit(context);
          return null;
        }

        var newBundleId = window.KavalriCartBundle && typeof window.KavalriCartBundle.createBundleId === 'function'
          ? window.KavalriCartBundle.createBundleId()
          : 'cart-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
        var parentProperties = requestedParentProperties;
        parentProperties._cart_bundle_id = newBundleId;
        parentProperties._cart_bundle_role = 'parent';
        if (Object.prototype.hasOwnProperty.call(parentProperties, '_pave_bundle_id')) {
          parentProperties._pave_bundle_id = newBundleId;
        }

        var newParent = {
          id: Number(variantId),
          quantity: Number(context.parentLine.quantity) || 1,
          properties: parentProperties
        };
        if (context.parentLine.selling_plan_allocation && context.parentLine.selling_plan_allocation.selling_plan) {
          newParent.selling_plan = context.parentLine.selling_plan_allocation.selling_plan.id;
        } else if (context.parentLine.selling_plan) {
          newParent.selling_plan = context.parentLine.selling_plan;
        }
        var replacementItems = [newParent];

        context.childLines.forEach(function(line) {
          var childProperties = getProperties(line);
          childProperties._cart_bundle_id = newBundleId;
          childProperties._cart_bundle_role = 'child';
          childProperties._cart_parent_variant_id = String(variantId);
          if (Object.prototype.hasOwnProperty.call(childProperties, '_pave_bundle_id')) {
            childProperties._pave_bundle_id = newBundleId;
          }
          if (Object.prototype.hasOwnProperty.call(childProperties, '_pave_parent_variant_id')) {
            childProperties._pave_parent_variant_id = String(variantId);
          }
          replacementItems.push(lineItemPayload(line, childProperties));
        });

        return postAdd(replacementItems).then(function() {
          return removeKeys(context.originalLineKeys).then(function(cart) {
            return verifyRemovedLines(cart, context.originalLineKeys);
          }).catch(function(error) {
            return rollbackBundle(newBundleId).then(function() { throw error; });
          });
        }).then(function() { finishEdit(context); });
      });
    });
  }

  function formProperties(formData) {
    var properties = {};
    formData.forEach(function(value, name) {
      var match = name.match(/^properties\[(.+)\]$/);
      if (match) {
        properties[match[1]] = value;
      }
    });
    return properties;
  }

  function initializeStandaloneForm(context) {
    if (!context || context.targetRole !== 'standalone') {
      return;
    }
    var form = document.querySelector('.product-single__form');
    if (!form) {
      return;
    }

    var quantityInput = form.querySelector('[name="quantity"]');
    if (quantityInput) {
      quantityInput.value = context.targetLine.quantity;
    }
    var lineProperties = getProperties(context.targetLine);
    function hydrateLineProperties() {
      Object.keys(lineProperties).forEach(function(name) {
        if (name.charAt(0) === '_') {
          return;
        }
        var expectedName = 'properties[' + name + ']';
        Array.prototype.filter.call(form.elements, function(element) {
          return element.name === expectedName;
        }).forEach(function(input) {
          var expectedValue = String(lineProperties[name]);
          if (input.type === 'checkbox' || input.type === 'radio') {
            if (input.checked !== (String(input.value) === expectedValue)) {
              input.checked = String(input.value) === expectedValue;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
          } else if (String(input.value) !== expectedValue) {
            input.value = expectedValue;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    }

    hydrateLineProperties();
    var propertyObserver = new MutationObserver(hydrateLineProperties);
    propertyObserver.observe(form, { childList: true, subtree: true });
    window.setTimeout(function() {
      propertyObserver.disconnect();
    }, 20000);

    var buttonText = form.querySelector('[data-add-to-cart-text]');
    if (buttonText) {
      var updateLabel = window.theme && window.theme.strings && window.theme.strings.cartUpdate
        ? window.theme.strings.cartUpdate
        : 'Update cart';
      buttonText.textContent = updateLabel;
      buttonText.dataset.defaultText = updateLabel;
    }

    function submitEdit(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      var submitButton = form.querySelector('[data-add-to-cart]');
      if (submitButton && submitButton.dataset.cartEditLoading === 'true') {
        return;
      }
      if (submitButton) {
        submitButton.dataset.cartEditLoading = 'true';
        submitButton.disabled = true;
        submitButton.classList.add('btn--loading');
      }
      var data = new FormData(form);
      replaceStandalone(
        data.get('id'),
        data.get('quantity') || context.targetLine.quantity,
        formProperties(data)
      ).catch(function(error) {
        alert(error.message);
        if (submitButton) {
          delete submitButton.dataset.cartEditLoading;
          submitButton.disabled = false;
          submitButton.classList.remove('btn--loading');
        }
      });
    }

    form.addEventListener('submit', submitEdit, true);
    var addToCartButton = form.querySelector('[data-add-to-cart]');
    if (addToCartButton) {
      addToCartButton.addEventListener('click', submitEdit, true);
    }
  }

  function initializeEditButtons(context) {
    if (!context) {
      return;
    }
    var updateLabel = window.theme && window.theme.strings && window.theme.strings.cartUpdate
      ? window.theme.strings.cartUpdate
      : 'Update cart';
    document.querySelectorAll('#choose-design-btn, [data-cart-edit-label]').forEach(function(button) {
      button.textContent = updateLabel;
      button.setAttribute('data-cart-edit-submit', 'true');
    });
  }

  function initializePage() {
    var editCartId = getEditId();
    if (!editCartId) {
      clearMarkedSelections('');
      clearAllEditCaches();
      return;
    }
    activeEditCartId = editCartId;

    getContext().then(stageContext).then(function(context) {
      initializeStandaloneForm(context);
      initializeEditButtons(context);
      document.documentElement.classList.add('cart-edit-active');
      document.dispatchEvent(new CustomEvent('cart-edit:ready', { detail: { context: context } }));
    }).catch(function(error) {
      console.error('Unable to initialize cart edit', error);
      if (error && error.code === 'CART_EDIT_LINE_NOT_FOUND') {
        clearEditState(editCartId);
        window.location.href = '/cart';
        return;
      }
      alert(error.message + ' Please return to your cart and try again.');
      clearEditState(editCartId);
      window.location.href = '/cart';
    });
  }

  document.addEventListener('click', function(event) {
    var editLink = event.target.closest('[data-cart-edit]');
    if (editLink) {
      event.preventDefault();
      if (editLink.dataset.cartEditLoading === 'true') {
        return;
      }
      editLink.dataset.cartEditLoading = 'true';
      editLink.setAttribute('aria-busy', 'true');
      var editCartId = editLink.dataset.cartEditId || '';
      activeEditCartId = editCartId;
      contextPromise = fetchCart().then(function(cart) {
        var context = buildContext(cart, editCartId, editLink);
        if (context.editCartId !== editCartId) {
          // Zapiet and other cart apps can add line properties after the
          // server-rendered Cart markup is ready, which changes Shopify's
          // line key. Keep the edit URL and DOM link on the current key.
          try {
            sessionStorage.removeItem(CACHE_PREFIX + editCartId);
          } catch (error) {
            // Session storage is best-effort only.
          }
          activeEditCartId = context.editCartId;
          editLink.dataset.cartEditId = context.editCartId;
          var refreshedHref = new URL(editLink.getAttribute('href') || '/cart', window.location.origin);
          refreshedHref.searchParams.set(EDIT_PARAM, context.editCartId);
          editLink.setAttribute('href', refreshedHref.pathname + refreshedHref.search + refreshedHref.hash);
        }
        return cacheContext(context);
      });
      contextPromise.then(stageContext).then(function(context) {
        window.location.href = getEditDestination(context);
      }).catch(function(error) {
        delete editLink.dataset.cartEditLoading;
        editLink.removeAttribute('aria-busy');
        if (error && error.code === 'CART_EDIT_LINE_NOT_FOUND') {
          clearEditState(editCartId);
          window.location.href = '/cart';
          return;
        }
        alert(error.message);
      });
      return;
    }

    var cancelButton = event.target.closest('[data-cart-edit-cancel]');
    if (cancelButton) {
      event.preventDefault();
      clearEditState();
      if (window.KavalriPaveOption && typeof window.KavalriPaveOption.clearSelection === 'function') {
        window.KavalriPaveOption.clearSelection();
      }
      window.location.href = '/cart';
    }
  }, true);

  window.KavalriCartEdit = {
    appendFlowParams: appendFlowParams,
    navigate: navigate,
    getEditId: getEditId,
    getContext: getContext,
    stageContext: stageContext,
    getFlowStoneType: getFlowStoneType,
    clear: clearEditState,
    replaceStandalone: replaceStandalone,
    replaceChild: replaceChild,
    replaceParent: replaceParent,
    isActive: function() { return Boolean(getEditId()); }
  };

  patchThemeCartRequests();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePage);
  } else {
    initializePage();
  }
})(window, document);
/** InsCoder 2026-08-17 E + URL-scoped cart editing for standalone products and ring/stone bundles. **/

/** InsCoder 2026-08-19 B + Theme-setting driven ring and stone compatibility messaging. **/
(function(window, document) {
  'use strict';

  var compatibilityObserver;

  function normalize(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/[\s_]+/g, '-')
      .replace(/-+/g, '-');
  }

  function readTags(parentLine) {
    var rawTags = parentLine && parentLine.dataset ? parentLine.dataset.cartProductTags : '';
    if (!rawTags || rawTags === 'null') {
      return [];
    }

    try {
      var parsedTags = JSON.parse(rawTags);
      if (Array.isArray(parsedTags)) {
        return parsedTags.map(normalize).filter(Boolean);
      }
    } catch (error) {
      // Older cached cart markup used a pipe-separated tag attribute.
    }

    return rawTags.split('|').map(normalize).filter(function(tag) {
      return tag && tag !== 'null';
    });
  }

  function readStoneLines(group) {
    return Array.prototype.filter.call(
      group.querySelectorAll('[data-cart-line-item][data-cart-role="child"]'),
      function(line) {
        return normalize(line.dataset.cartChildLabel) !== 'add-on';
      }
    );
  }

  function readStoneSide(line) {
    var side = normalize(line && line.dataset ? line.dataset.cartChildOptionKey : '');

    if (side === 'left' || side === 'left-stone') {
      return 'left';
    }
    if (side === 'right' || side === 'right-stone') {
      return 'right';
    }

    return '';
  }

  function readStoneShape(line) {
    return normalize(line && line.dataset ? line.dataset.cartChildShape : '');
  }

  function isToiEtMoi(tags) {
    return tags.indexOf('toietmoi') !== -1 || tags.indexOf('toi-et-moi') !== -1 || tags.some(function(tag) {
      return tag.indexOf('left-stone-') === 0 || tag.indexOf('right-stone-') === 0;
    });
  }

  function hasCompatibleShapeTag(tags, shape) {
    if (!shape) {
      return null;
    }

    if (tags.indexOf(shape) !== -1) {
      return true;
    }

    // The existing diamond and gemstone filters treat cushion as matching
    // both cushion and elongated-cushion ring tags.
    if (
      (shape === 'cushion' && tags.indexOf('elongated-cushion') !== -1) ||
      (shape === 'elongated-cushion' && tags.indexOf('cushion') !== -1)
    ) {
      return true;
    }

    return false;
  }

  function evaluateGroup(group) {
    var parentLine = group && group.querySelector('[data-cart-line-item--parent]');
    var tags = readTags(parentLine);
    var stones = group ? readStoneLines(group) : [];

    if (!parentLine || !tags.length || !stones.length) {
      return 'unknown';
    }

    if (isToiEtMoi(tags)) {
      for (var sideIndex = 0; sideIndex < stones.length; sideIndex += 1) {
        var side = readStoneSide(stones[sideIndex]);
        var sideShape = readStoneShape(stones[sideIndex]);

        // Do not infer left/right from DOM order. Legacy carts without side
        // metadata must remain checkout-safe and warning-free.
        if (!side || !sideShape) {
          return 'unknown';
        }

        if (tags.indexOf(side + '-stone-' + sideShape) === -1) {
          return 'incompatible';
        }
      }

      return 'compatible';
    }

    for (var stoneIndex = 0; stoneIndex < stones.length; stoneIndex += 1) {
      var shape = readStoneShape(stones[stoneIndex]);
      var shapeMatch = hasCompatibleShapeTag(tags, shape);

      if (shapeMatch === null) {
        return 'unknown';
      }
      if (!shapeMatch) {
        return 'incompatible';
      }
    }

    return 'compatible';
  }

  function setHidden(element, hidden) {
    if (!element) {
      return;
    }

    element.hidden = hidden;
    element.setAttribute('aria-hidden', String(hidden));
  }

  function syncCompatibility() {
    var groups = document.querySelectorAll('[data-cart-compatibility-group]');
    var hasIncompatibleGroup = false;

    groups.forEach(function(group) {
      var state = evaluateGroup(group);
      var alert = group.querySelector('[data-cart-compatibility-alert]');

      group.dataset.cartCompatibilityState = state;
      setHidden(alert, state !== 'incompatible');
      if (state === 'incompatible') {
        hasIncompatibleGroup = true;
      }
    });

    document.querySelectorAll('[data-cart-incompatible-checkout-note]').forEach(function(note) {
      setHidden(note, !hasIncompatibleGroup);
    });

    return hasIncompatibleGroup;
  }

  function observeCartMarkup() {
    if (compatibilityObserver || typeof MutationObserver === 'undefined') {
      return;
    }

    compatibilityObserver = new MutationObserver(function() {
      syncCompatibility();
    });

    document.querySelectorAll('[data-products]').forEach(function(products) {
      compatibilityObserver.observe(products, { childList: true, subtree: true });
    });
  }

  document.addEventListener('cart:updated', syncCompatibility);
  document.addEventListener('DOMContentLoaded', function() {
    observeCartMarkup();
    syncCompatibility();
  });

  window.KavalriCartCompatibility = {
    evaluateGroup: evaluateGroup,
    sync: syncCompatibility
  };

  if (document.readyState !== 'loading') {
    observeCartMarkup();
    syncCompatibility();
  }
})(window, document);
